import React from 'react';
import { Search, X } from 'lucide-react';

const SearchBox = ({
  searchInput,
  setSearchInput,
  setSearchTerm,
  setCurrentPage,
  placeholder = 'Search…',
  disabled = false,
}) => {
  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchInput(value);

    if (value.trim() === '') {
      setSearchTerm('');
      setCurrentPage(1);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      setSearchTerm(searchInput.trim());
      setCurrentPage(1);
    }
  };

  const handleClear = () => {
    setSearchInput('');
    setSearchTerm('');
    setCurrentPage(1);
  };

  return (
    <div
      className="search-box"
      style={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        border:  disabled ? '1px solid var(--Gray-400, #CED4DA)' : '1px solid var(--Gray-600, #6C757D)',
        background: disabled ? 'var(--Gray-100, #F8F9FA)' : 'var(--Default-White, #FFF)',
        borderRadius: disabled ? undefined : '8px',
        cursor: disabled ? 'not-allowed' : 'default',
      }}
    >
      <Search size={20} color={disabled ? '#CED4DA' : '#6C757D'} />

      {disabled && (
        <style>{`.search-box-disabled::placeholder { color: #CED4DA !important; }`}</style>
      )}
      <input
        type="text"
        placeholder={placeholder}
        value={searchInput}
        onChange={!disabled ? handleInputChange : undefined} // disable input logic
        onKeyDown={!disabled ? handleKeyDown : undefined}
        disabled={disabled}
        className={disabled ? 'search-box-disabled' : undefined}
        style={{
          paddingRight: '28px',
          flex: 1,
          background: 'transparent',
          border: 'none',
          outline: 'none',
          color: disabled ? '#ADB5BD' : 'inherit',
        }}
      />

      {!disabled && searchInput && (
        <button
          onClick={handleClear}
          style={{
            position: 'absolute',
            right: '4px',
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '4px',
          }}
        >
          <X size={16} />
        </button>
      )}
    </div>

  );
};

export default SearchBox;